import "./Styles/event-detail.scss";
import "./Styles/add-new-channel.scss";
import "react-toggle/style.css";

import React, { useState, useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";
import FieldSelect from "../../Components/Fields/FieldSelect";
import FieldCheckbox from "../../Components/Fields/FieldCheckbox";
import AlertComponent from "../../Components/AlertComponent";
import TimeRangePicker from "../../Components/TimeRangePicker/TimeRangePicker";

function AddNewProgram(props) {
  const { inputs = [], firstItem, handleAdd, startTime, minTime } = props;
  const [inputOption, setInputOption] = useState([]);
  const [switchType, setSwitchType] = useState([]);
  const [loop, setLoop] = useState(false);
  const [time, setTime] = useState(false);

  const [selectedInput, setSelectedInput] = useState(null);
  const [selectedSwitch, setSelectedSwitch] = useState(null);

  useEffect(() => {
    setInputOption(
      inputs.map((x) => {
        return { id: x.id, label: `${x.name} - ${x.inputType}` };
      })
    );

    let switchTypeOptions = [
      { id: "Following", label: "Following" },
      { id: "FixedTime", label: "Fixed Time" },
    ];

    if (firstItem) {
      switchTypeOptions = switchTypeOptions.splice(1, 1);
      setSelectedSwitch({ id: "FixedTime", label: "Fixed Time" });
      setTime(startTime);
    }

    setSwitchType(switchTypeOptions);
  }, [0]);

  const handleAddItem = () => {
    if (!selectedInput) {
      return AlertComponent("Error", "Input is required", {
        icon: `error`,
      });
    }

    if (!selectedSwitch) {
      return AlertComponent("Error", "Switch Type is required", {
        icon: `error`,
      });
    }
    const hasTime = selectedSwitch?.id !== `Following`;

    if (hasTime && !time) {
      return AlertComponent("Error", "Time is required", {
        icon: `error`,
      });
    }

    const mp4File = inputs?.filter(
      (item) => item.id === selectedInput?.id && item.inputType == 'MP4'
    ).length;

    const item = {
      id: selectedInput.id,
      time: hasTime ? time : null,
      title: selectedInput.label,
      blocked: false,
      type: selectedSwitch.id,
    };

    if (mp4File) {
      item.loop = loop;
    }

    handleAdd(item);
  };

  const mp4File = inputs?.filter(
    (item) => item.id === selectedInput?.id && item.inputType == 'MP4'
  ).length;
  
  const hasTime = selectedSwitch && selectedSwitch.id !== `Following`;

  return (
    <Row>
      <Col md={12} className="new-program mt-4">
        <div className="cc-card">
          <h5>Add Program</h5>
          <Row>
            <Col md={4}>
            <FieldSelect
              label={`Select Input`}
              options={inputOption}
              id={`selected_input`}
              name={`selected_input`}
              onChange={setSelectedInput}
              value={selectedInput}
              multiple={false}
              required={true}
            />
            </Col>
            <Col md={3}>
              <FieldSelect
                label={`Select Input`}
                options={switchType}
                id={`selected_input`}
                name={`selected_input`}
                onChange={setSelectedSwitch}
                value={selectedSwitch}
                multiple={false}
                required={true}
                readonly={firstItem}
              />
            </Col>
            {hasTime && (
              <Col md={3}>
                <div className="form-group">
                  <TimeRangePicker
                    setStartTime={setTime}
                    startTimeLabel={`Time`}
                    startTime={startTime}
                    readOnly={firstItem}
                    minTime={minTime}
                  />
                </div>
               
              </Col>
            )}
            
            {mp4File > 0 && (
              <Col md={2}>
                <FieldCheckbox
                  className="col-md-2"
                  label={`Loop`}
                  onChange={setLoop}
                  checked={loop}
                  group={`available`}
                />
              </Col>
            )}
          </Row>
          <Row>
            <Col md={12}>
              <Button variant="dark" className="dark-btn" onClick={handleAddItem}>
                Add Program
              </Button>
            </Col>
          </Row>
        </div>
      </Col>
    </Row>
  );
}

export default AddNewProgram;
